export enum QuitusStatus {
    WAITING = '1',
    TRANSMITTED = '2',
    TREATED = '3',
    ARCHIVED = '4'
}

export type FollowUpValues = 1 | 2 | 3;

export type Quitus = {
    id: string;
    worksite_id: string;
    status: QuitusStatus;
    title: string;
    apartment: string;
    worksite: string;
    date_create: string;
};

export type GetQuitusesResponse = Quitus[];

export type QuitusType = {
    id: string;
    label: string;
};

export type GetQuitusTypesResponse = QuitusType[];

export type QuitusContent = {
    id: string;
    id_user: string;
    call_date: string;
    call_by: string;
    client: string;
    worksite_id: string;
    apartment_id: string;
    building_id: string;
    address: string;
    phone_number: string;
    cellphone_number: string;
    type: Pick<QuitusType, 'id'>;
    status: QuitusStatus;
    other: string;
    start_time: string;
    end_time: string;
    moving_rate_id: string;
    observations: string;
    request_nature: string;
    completed_works: string;
    client_signature: string;
    done_at: string;
    done_where: string;
    date_create: string;
    apartment_other: string;
    disabled: Array<string>;
    follow_up: Array<FollowUpValues>;
    operator_id: string;
};

export type GetQuitusContentResponse = QuitusContent;

export type GetQuitusContentPayload = {
    quitusId: string;
};

export type CreateQuitusPayload = {
    id?: number;
    call_date: string;
    call_by: string;
    client: string;
    address: string;
    phone_number: string;
    cellphone_number: string;
    type: number;
    other: string;
    start_time: string;
    end_time: string;
    observations: string;
    request_nature: string;
    completed_works: string;
    worksite_id: number;
    apartment_id: number;
    building_id: number;
    apartment_other: string;
    follow_up: Array<FollowUpValues>;
    images: Array<string>;
    client_signature: string;
};
